export const Roles = {
    TEACHER: 'TEACHER',
    STUDENT: 'STUDENT',
    EDITOR: 'EDITOR',
    GUEST: 'GUEST',
};
